import { absolutePath } from "./absolutePath";

interface GamificationFnProps {
  params?: Record<string, unknown>;
  pointAwardId?: string | number;
}

export const gamification = {
  settings: ({ params = {} }: GamificationFnProps = {}) =>
    absolutePath("/gamification/settings", params),
  members: ({ params = {} }: GamificationFnProps = {}) =>
    absolutePath("/gamification/members", params),
  leaderboard: ({ params = {} }: GamificationFnProps = {}) =>
    absolutePath("/gamification/leaderboard", params),
  pointAwards: ({ params = {} }: GamificationFnProps = {}) =>
    absolutePath("/gamification/point_awards", params),
  revokePointAward: ({ pointAwardId }: GamificationFnProps) =>
    absolutePath(`/gamification/point_awards/${pointAwardId}/undo`),
  resetPoints: () => absolutePath("/gamification/point_resets"),
  undoReset: () => absolutePath("/gamification/point_resets/undo"),
};
